export const LANDING = '/';
export const LOG_IN = '/login';
export const LOG_OUT = '/logout';
export const CREATE = '/create';
export const EDIT = '/edit/:sona_id';
export const HOME = '/home';
export const VIEW_SONA = '/sona/:sona_code';
export const PROFILE = '/profile';
export const ANALYZE = '/analyze/:sona_id';
export const ADMIN = '/admin';
export const EULA = '/eula';
